<c-card *ngIf="monitor">
  <c-card-body *transloco="let t" class="px-2">


          <c-row>
            <c-col md="12" lg="6">
                <h3>{{ t('Update') }} {{monitor.name}}</h3>
            </c-col>
            <c-col md="12" lg="6" class="text-end mb-2">

              <div class="btn-group mb-2 " role="group">
              <button color="light" cButton  routerLink="/mgmt/monitors/monitors-privacy">
                  <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                  {{ t('Return to Monitors') }}
              </button>
              <a href="https://okalone.zendesk.com/hc/en-gb/categories/35344534733713-Monitors" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>

              </div>

            </c-col>
          </c-row>

        <c-row class="justify-content-left">
          <c-col>


                    <div class="row">
                      <div class="col-md-6">


                        <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Name') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'name'"
                              cFormControl
                              placeholder="{{ t('Name') }}"
                              [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('A suitable name for this monitor')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['name'].errors" class="invalid-feedback">
                                {{ t('A valid name is required": "A valid name is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilEnvelopeClosed"></svg> {{ t('Email') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'email'"
                              cFormControl
                              placeholder="{{ t('Email') }}"
                              [ngClass]="{ 'border-danger': submitted && f['email'].errors }"
                              [attr.disabled]="monitor.fa2 && monitor.email"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for email alerts')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                                {{ t('A valid email is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilMobile"></svg> {{ t('Cell Number') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone'"
                              cFormControl
                              placeholder="{{ t('For Text Messages') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone'].errors }"
                              [attr.disabled]="monitor.fa2 && monitor.phone"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for SMS alerts - please use the international code such as +44 for UK, or +1 for Canada. Can be the same as the Phone Number.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone'].errors" class="invalid-feedback">
                                {{ t('A valid phone number is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Phone Number') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone2'"
                              cFormControl
                              placeholder="{{ t('For Phone Calls') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone2'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for phone call alerts - please use the international code such as +44 for UK, or +1 for Canada. Can be the same as the Cell Number.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone2'].errors" class="invalid-feedback">
                                {{ t('A valid phone number is required') }}
                            </div>
                          </div>
                        </div>


                      <button cButton class="px-4 mb-2 text-white btn-info" type="submit">
                        <i class="fa-solid fa-check"></i> {{ t('Update the Monitor') }}
                      </button>

                    </form>

                      </div>
                      <div class="col-md-6">


                      </div>
                    </div>


          </c-col>
        </c-row>

  </c-card-body>
</c-card>
